export const parseValue = ({ place, calendar, occupation, promocode } = {}) => ({
  place,
  calendar,
  occupation,
  promocode,
});
